import { render, staticRenderFns } from "./treeSetting.vue?vue&type=template&id=348b3dc8&lang=pug"
import script from "./treeSetting.vue?vue&type=script&lang=js"
export * from "./treeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports